import { useEffect, useState } from 'react'
import { api, Project } from '../api/projects'

function Timeline() {
  const [projects, setProjects] = useState<Project[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    api.getActiveProjects()
      .then(setProjects)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div>Loading timeline...</div>
  if (error) return <div style={{ color: 'red' }}>Error: {error}</div>

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Project Timeline</h2>
      {projects.length === 0 && <p>No active projects.</p>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {projects.map((p) => (
          <div
            key={p.id}
            style={{
              border: '1px solid #ccc',
              borderRadius: '8px',
              padding: '1rem',
              background: '#fafafa',
            }}
          >
            <h3 style={{ margin: '0 0 0.5rem' }}>{p.name}</h3>
            <p style={{ margin: '0.25rem 0', fontSize: '0.9rem', color: '#555' }}>
              {p.start_date && <span>Start: {p.start_date.split('T')[0]} </span>}
              {p.end_date && <span>• End: {p.end_date.split('T')[0]}</span>}
            </p>
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '0.5rem' }}>
              {p.deliverables.map((d) => (
                <span
                  key={d.id}
                  style={{
                    padding: '0.25rem 0.5rem',
                    borderRadius: '4px',
                    fontSize: '0.8rem',
                    background:
                      d.status === 'done'
                        ? '#d4edda'
                        : d.status === 'at_risk'
                        ? '#f8d7da'
                        : d.status === 'in_progress'
                        ? '#fff3cd'
                        : '#e2e3e5',
                    color:
                      d.status === 'done'
                        ? '#155724'
                        : d.status === 'at_risk'
                        ? '#721c24'
                        : d.status === 'in_progress'
                        ? '#856404'
                        : '#383d41',
                  }}
                >
                  {d.name}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Timeline
